import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Make sure ScrollTrigger is registered
gsap.registerPlugin(ScrollTrigger);

type RefType = {
  current: HTMLElement | null;
};

// Animation for location content (title and description)
export const animateLocation = (
  contentRef: RefType,
  cardRef: RefType,
  sectionRef: RefType,
  mapRef: RefType
) => {
  if (!contentRef.current || !cardRef.current || !sectionRef.current) return;

  // Animation for the heading and description
  const contentElements = contentRef.current.children;
  gsap.fromTo(
    contentElements,
    {
      opacity: 0,
      y: 30,
    },
    {
      opacity: 1,
      y: 0,
      duration: 0.8,
      stagger: 0.2,
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 80%",
      },
    }
  );

  // Animation for the map container
  if (mapRef.current) {
    gsap.fromTo(
      mapRef.current,
      {
        opacity: 0,
        x: -40,
        scale: 0.95,
      },
      {
        opacity: 1,
        x: 0,
        scale: 1,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 70%",
        },
      }
    );
  }

  // Animation for the location card
  gsap.fromTo(
    cardRef.current,
    {
      opacity: 0,
      x: 40,
      scale: 0.95,
    },
    {
      opacity: 1,
      x: 0,
      scale: 1,
      duration: 1,
      ease: "power2.out",
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 70%",
      },
    }
  );
};

// Cleanup function for ScrollTrigger instances
export const cleanupLocationScrollTriggers = () => {
  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
};
